import { environment } from '../../../environments/environment';

/**
 * ESS is served at the root of its own hostname (environment.essHost, the former ESS dashboard DNS); on the New PTM
 * hostname, and in environments without an ESS hostname, it is under /ess.
 */
export const IS_ESS_HOST = !!environment.essHost && window.location.hostname === environment.essHost;

export const ESS_BASE_URL = IS_ESS_HOST ? '' : '/ess';

/** Origin of the ESS hostname, keeping the current protocol and port (e.g. for ess.localhost:4200). */
export function essHostOrigin(): string {
  const port = window.location.port ? ':' + window.location.port : '';
  return `${window.location.protocol}//${environment.essHost}${port}`;
}
